module.exports = __webpack_public_path__ + "static/media/death-of-a-phoenix.a996e0ed.webp";